// extracted by mini-css-extract-plugin
export default {"area":"TextAreaWithLabel_area__Q9gHH","label":"TextAreaWithLabel_label__N1-J7","errorMessage":"TextAreaWithLabel_errorMessage__XA4ae"};